import { CodedProperty, getFileNameWithExtension, NamedProperty } from "sprint-common-web";

import { GetFileRecordListResponseItem } from "../../../../common/api/master-api/file-records/get-list/GetFileRecordListResponse";
import { NoteItem } from "../../../../common/components/notes/hooks/state/NoteItem";
import { resolveContentTitle, resolveContentVersion } from "../../../../common/types/ContentReference";
import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";
import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { RecordType } from "../../../../common/types/RecordType";
import { StorageType } from "../../../../common/types/StorageType";
import { FileRecordStatusDetails } from "../../common/types/FileRecordStatusDetails";

export interface FileRecordListingItem {
    id: string;
    content: string | undefined;
    versions: string[];
    filePath: string | undefined;
    deliveryFileName: string;
    recordType: RecordType;
    storageType: StorageType;
    createdDate: string;
    updatedDate: string;
    deliveryRef?: string;
    contentType?: ContentReferenceType;
    status: FileRecordStatus;
    subtitle?: Subtitle;
    soundtracks: CodedProperty[];
    aspectRatio?: NamedProperty;
    isNotificationApproved: boolean;
    subtitleType?: number;
    originator?: NamedProperty;
    arrivalDate: string;
    isModified?: boolean;
    notes: NoteItem[];
    statusDetails?: FileRecordStatusDetails;
    duration?: string;
    isTrailer: boolean;
}

type Subtitle = CodedProperty & {
    type: FileRecordDocumentSubtitleEmbeddingType;
};

enum FileRecordDocumentSubtitleEmbeddingType {
    Clean = 1,
    Embedded = 2,
    Dynamic = 3
}

export const mapToFileRecordListingItem = (item: GetFileRecordListResponseItem): FileRecordListingItem => ({
    id: item.id,
    deliveryRef: item.deliveryRef,
    recordType: item.recordType,
    storageType: item.storageType,
    content: item.content ? resolveContentTitle(item.content) : undefined,
    contentType: item.content?.type,
    versions: item.content ? resolveContentVersion(item.content) : [],
    deliveryFileName: getFileNameWithExtension(item.deliveryFile.path),
    filePath: item.path,
    createdDate: item.createdDate,
    updatedDate: item.updatedDate,
    soundtracks: item.soundtracks,
    subtitle: item.subtitle,
    aspectRatio: item.aspectRatio,
    arrivalDate: item.arrivalDate,
    originator: item.originator,
    subtitleType: item.subtitleType,
    notes: [],
    status: item.status,
    isNotificationApproved: item.isNotificationApproved,
    statusDetails: item.statusDetails,
    duration: item.duration,
    isTrailer: item.isTrailer
});
